jQuery(document).ready(function ($) {

  $('.akkordeon-item-title').click(function (event) {
    event.preventDefault();
    _this = this;
    $target = $(_this).next();

    // other items
    $arrItems =  $(_this).parent().siblings();
    $arrItems.each(function(){
      $this = $(this).find('.akkordeon-item-title');
      if($this.hasClass('is-open')){
        $this.removeClass('is-open');
        $this.next().slideToggle();
      }
    });

    $target.slideToggle();
    $(_this).toggleClass('is-open');

  });

});
